<template>
  <nd-dialog
    v-model="visible"
    :footer="false"
    class="reconfirm-dialog"
  >
    <template v-if="['LOAN_UP_AMT', 'LOAN_BIZ_UP_AMT'].includes(data.loanPopType)">
      <img src="../image/icon_loan_up_amt.png" class="top-image">
    </template>
    <template v-else>
      <img src="../image/icon_loan_coupon_discount.png" class="top-image">
    </template>
    <div
      v-if="sensorsCaseId"
      class="content"
      :data-sensors-exposure-property-msg_name="sensorsMessagesName"
      :data-sensors-exposure-property-caseId="sensorsCaseId"
      data-sensors-exposure-event-name="PopupDisplay"
    >
      <template v-if="data.loanPopType === 'LOAN_BIZ_UP_AMT'">
        <div
          class="font-size-50 semi-bold text-dark"
          :class="{'mt-80': data.loanPopType==='LOAN_BIZ_UP_AMT'}"
        >
          {{ title }}{{ data.amt }}{{ dataUnit }}
        </div>
        <div class="font-size-36 mt-8 color-gray">
          {{ descContent }}
        </div>
      </template>
      <template v-else>
        <div class="font-size-36 mt-80 semi-bold text-dark">{{ title }}</div>
        <div class="info font-size-80 semi-bold text-dark">
          {{ descContent }}<span class="text-primary">{{ dataContent }}</span>{{ dataUnit }}
        </div>
        <div class="expire-date font-size-24 text-dark">
          有效期：{{ data.expireDay | date('YYYY年M月D日') }}
        </div>
      </template>
      <nd-button
        class="continue"
        @click="continueAction"
      >
        {{ mainButtonText }}
      </nd-button>
      <div @click="giveUpAction" class="give-up font-size-24">放弃</div>
    </div>
  </nd-dialog>
</template>

<script>
export default {
  name: 'ReconfirmDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({
        /**
         * 用于区分弹窗类型
         * 'LOAN_UP_AMT' 为提现弹窗提升额度
         * 'LOAN_COUPON_DISCOUNT' 为提现弹窗免息券
         * 'LOAN_BIZ_UP_AMT' 提现弹窗业务提升额度
         */
        loanPopType: 'LOAN_UP_AMT',
        amt: 0,
        couponDiscountValue: 0,
        expireDay: 0
      })
    }
  },
  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    title () {
      if (this.data.loanPopType === 'LOAN_UP_AMT') {
        return '你的信用良好 平台已为你'
      } else if (this.data.loanPopType === 'LOAN_COUPON_DISCOUNT') {
        return '今日提现超优惠 平台已为你'
      } else {
        return '限时最高提'
      }
    },
    descContent () {
      if (this.data.loanPopType === 'LOAN_UP_AMT') {
        return '提额'
      } else if (this.data.loanPopType === 'LOAN_COUPON_DISCOUNT') {
        return '免息'
      } else {
        return '恭喜你额度上升了'
      }
    },
    dataUnit () {
      if (['LOAN_UP_AMT', 'LOAN_BIZ_UP_AMT'].includes(this.data.loanPopType)) {
        return '元'
      } else {
        return '天'
      }
    },
    dataContent () {
      return this.data.loanPopType === 'LOAN_UP_AMT' ? this.data.amt : this.data.couponDiscountValue
    },
    sensorsMessagesName () {
      return 'retain'
    },
    sensorsCaseId () {
      return this.data.loanPopType
    },
    mainButtonText () {
      return this.data.loanPopType === 'LOAN_BIZ_UP_AMT' ? '立即提现' : '继续提现'
    }
  },
  methods: {
    continueAction () {
      this.visible = false
    },
    giveUpAction () {
      this.visible = false
      this.$emit('onGiveUp')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.reconfirm-dialog {
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 30px;
    .info {
      margin-top: -4px;
    }
    .expire-date {
      margin-top: -4px;
    }
    .continue {
      width: 320px;
      height: 80px;
      margin-top: 40px;
    }
    .give-up {
      margin-top: 27px;
      text-decoration: underline;
      color: #999;
    }
  }
  img {
    &.top-image {
      position: absolute;
      top: -95px;
      left: 167px;
      width: 305px;
      height: 179px;
    }
  }
}

.font-size-80 {
  font-size: 80px;
}
.font-size-50 {
  font-size: 50px;
}
.font-size-36 {
  font-size: 36px;
}
.font-size-32 {
  font-size: 32px;
}
.font-size-24 {
  font-size: 24px;
}
.semi-bold {
  font-weight: 600;
}
.text-primary {
  color: #FF5434;
}
.text-dark {
  color: #333;
}
.mt-8 {
  margin-top: 8px;
}
.mt-80 {
  margin-top: 80px;
}
.color-gray {
  color: #666;
}
</style>